export default {
  metaPixelId: '234460490977890',
};
